// Anchor for the crisis-resources section on /safeword. One constant shared by the quick-actions "Crisis lines"
// action (which navigates to `/safeword#crisis-resources`) and the section that scrolls itself into view.
export const CRISIS_RESOURCES_ID = 'crisis-resources';
